module.exports = __webpack_public_path__ + "img/eth.a30b3d6f.svg";